module.exports = __webpack_public_path__ + "img/CMHK_03_zhTc.39670266.png";